// Effect Managers
import { put, call, fork } from 'redux-saga/effects'

// Exports
export default function composeCreate ({
  state,
  actionCreators,
  handler,
}) {
  const create = function *create (
    { url, queryParams, model = {} } = {},
    { block = true, meta = {} } = {}
  ) {
    // Dispatch the create action if the saga is called non-blocking
    if (!block && state.get().watch.create) {
      // Create 'CREATE' action
      const action = actionCreators.create({
        url,
        queryParams,
        model,
      }, {
        meta,
      })

      // Dispatch 'CREATE' action
      yield put(action)
    } else {
      const result = yield call(handler, { url, queryParams, model }, meta)
      return result
    }
  }

  const createNonBlocking =
    function *createNonBlocking (
      payload = {},
      { meta = {} } = {}
    ) {
      yield fork(create, payload, {
        block: false,
        meta,
      })
    }

  return {
    create,
    createNonBlocking,
  }
}
